import _createClass from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
var r = /*#__PURE__*/function (_Error) {
  _inherits(r, _Error);
  var _super = _createSuper(r);
  function r(_r, e) {
    var _this;
    _classCallCheck(this, r);
    _this = _super.call(this, _r), _this.name = "SyntheticChangeError", _this.cause = e;
    return _this;
  }
  return _createClass(r);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export { r as default };